import { bool } from "prop-types";
import { observer } from "mobx-react";
import { Tables, hashCode } from "@repo/utils";
import {
  useUserVisibleWorkTypes,
  useEstimateEditorSettings,
  useEstimateEditorStore,
  useEstimateStructure,
  useVisibilityModeCellClassName,
  VisibilityButton,
} from "@tools";
import { ButtonSwitch } from "@components";
import { Collapse } from "@material-ui/core";
import { TimelineUtilizationRowGroupList } from "../../TimelineUtilization/TimelineUtilizationRowGroupList";
import { TimelineMenuTitle } from "../components/TimelineMenuTitle";
import { BarChartSide, TableChart } from "@assets";

export const TimelineUtilization = observer(({ isFirst }) => {
  
  const structure = useEstimateStructure();
  const { visibilityMode } = useEstimateEditorStore();
  const {
    isProposal,
    allowEdition,
    blockExpansions,
    isPdfPrinterView,
  } = useEstimateEditorSettings();
  
  const { settings, visibility, timelineWorkTypes } = structure;
  const { expandTimelineUtilization, useTimelineChart } = settings;
  const { hideTimelineUtilization } = visibility;
  
  const className = useVisibilityModeCellClassName(hideTimelineUtilization);
  
  const visibleWorkTypes = useUserVisibleWorkTypes(timelineWorkTypes, isProposal, true);
  
  const handleTimelineAllocationVisibility = () => {
    if(blockExpansions) return;
    settings.setExpandTimelineUtilization(!expandTimelineUtilization);
  }
  
  const handleWorkTypeReorder = (list) => {
    structure.reorderWorkTypes(list, true);
  }

  const handleTimelineChartSelect = (v) => {
    if(blockExpansions) return;
    structure.settings.setUseTimelineChart(v);
  }
  
  return (
    <>
      <TimelineMenuTitle
        code="utilization"
        isFirst={isFirst}
        expandable
        expanded={expandTimelineUtilization}
        onExpand={handleTimelineAllocationVisibility}
        className={className}
        actions={visibilityMode &&
          <VisibilityButton hidden={hideTimelineUtilization} onChange={visibility.setHideTimelineUtilization} />
        }
      >
        {
          !visibilityMode && !isPdfPrinterView &&
          <ButtonSwitch
            value={useTimelineChart}
            setValue={handleTimelineChartSelect}
            width={32}
            height={24}
            lighter
            values={[
              { value: false, label: <TableChart className="text-lg" /> },
              { value: true, label: <BarChartSide className="text-lg" /> },
            ]}
            size="small"
          />
        }
      </TimelineMenuTitle>
      <Collapse
        in={expandTimelineUtilization}
        timeout="auto"
        mountOnEnter
        unmountOnExit
        className={className}
        data-id={hashCode("cont")}
        data-t={Tables.TIMELINE}
        data-p={hashCode(Tables.TIMELINE)}
      >
        <TimelineUtilizationRowGroupList
          listElements={visibleWorkTypes}
          onReorder={handleWorkTypeReorder}
          disabled={!allowEdition}
          hashedPath={[hashCode(Tables.TIMELINE)]}
        />
      </Collapse>
    </>
  );
});

TimelineUtilization.propTypes = {
  isFirst: bool,
};
